module.exports = "/images/ce4e7de53a1530500dc115fe78df975a.png";